'use client';

import { use } from 'react';
import { ArticleSectionRelated } from '@/app_components/ArticleSections/ArticleSectionRelated';
import type { ArticlePreview } from '@/app_lib/types/ArticlePreview';

export const MostPopular = ({ articlesPromise }: { articlesPromise: Promise<ArticlePreview[]> }) => {
  const articles = use(articlesPromise);

  return (
    <ArticleSectionRelated
      articles={articles}
      heading='Most Popular'
    />
  );
};
